<template>
	<div class="px-3 pt-0 pb-3">
    <UplimitStepWithNextDay  @show_sidebar="show_sidebar"></UplimitStepWithNextDay>
    <StockInfoSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" :date_mark="date_mark" @date-mark-change="onDateMarkChange"></StockInfoSidebar>
	</div>
</template>

<script>
	import UplimitStepWithNextDay from 'components/uplimit/UplimitStepWithNextDay.vue'
	import StockInfoSidebar from 'components/stock/StockInfoSidebar.vue'
	
	export default {
        data() {
            return {
                symbol_code:'603069',
                symbol_name:'',
                date_mark:''
            }
        },
		components: {
			UplimitStepWithNextDay,
			StockInfoSidebar,
		},
        methods: {
            show_sidebar(stock_info){
                this.symbol_code=stock_info['stock_code'];
                this.symbol_name=stock_info['stock_name'];
                this.date_mark = stock_info['date1'] || this.date_mark || ''
            }
            ,onDateMarkChange(date){ this.date_mark = date || '' }
        }
	}
</script>

<style>
</style>
